export const domainsATHM = [
  'www.autohome.com.cn',
  'chejiahao.autohome.com.cn',
  'live.autohome.com.cn',
  'car.autohome.com.cn',
  'mall.autohome.com.cn',
  'dealer.autohome.com.cn',
  'www.che168.com',
  'j.autohome.com.cn',
  'club.autohome.com.cn',
  'k.autohome.com.cn',
  'jia.autohome.com.cn'
]
export const domainsOther = [
  'www.jd.com',
  'www.baidu.com',
  'www.taobao.com',
  'www.aliyun.com',
  'www.qq.com',
  'www.sina.com.cn',
  'www.douyin.com'
]

export const formatDelay = function ({delay, type}) {
  if (type === 'timeout') return `网络差，延迟大于${delay}毫秒`
  return `网络正常，延时${delay}毫秒`
}

export const checkDomain = function (domain, cb) {
  return new Promise((resolve, reject) => {
    let start = new Date
    let image = new Image
    let handler, timeout
    handler = (delay, type) => {
      clearTimeout(timeout)
      image.onerror = image.onload = null
      cb(domain, delay, type)
      resolve({domain, delay})
    }
    timeout = setTimeout(() => handler(6000, 'timeout'), 6000) //超时回调
    image.onerror = () => handler(new Date - start, 'onerror') //错误响应回调
    image.onload = () => handler(new Date - start, 'onload')  //Load响应回调
    image.src = 'http://' + domain + '/?r=' + (Math.random() * 100000)
  })
}

export const checkDomains = function (cb) {
  let domains = domainsATHM.concat(domainsOther)
  let tasks = domains.map(domain => () => checkDomain(domain, cb))
  return Promise.serial(tasks)
}


